import type { Cookie } from "@spwn/types/functions";

/**
 * CloudFront用のURL safe変換
 * @see https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/private-content-creating-signed-url-custom-policy.html#private-content-custom-policy-creating-signature
 */
const toUrlSafe = (str: string): string => {
  return str.replace(/\+/g, "-").replace(/=/g, "_").replace(/\//g, "~");
};

const createPresignedUrlQueryParameter = (cookie: Cookie["cookie"]): string => {
  const {
    "CloudFront-Key-Pair-Id": keyPairId,
    "CloudFront-Policy": policy,
    "CloudFront-Signature": signature,
  } = cookie;

  const params = [
    `Policy=${toUrlSafe(policy)}`,
    `Signature=${toUrlSafe(signature)}`,
    `Key-Pair-Id=${keyPairId}`,
  ].join("&");

  return params;
};

export const generateSignedM3u8Url = (
  manifestFileUrl: string,
  cookie: Cookie["cookie"]
): string => {
  const params = createPresignedUrlQueryParameter(cookie);
  return `${manifestFileUrl}?${params}`;
};

/**
 * @description manifestFileUrlの最後のpath部分を特定のファイル名に置き換えた署名付きURLを生成する
 */
export const generateSignedUrl = ({
  manifestFileUrl,
  cookie,
  fileName,
}: {
  manifestFileUrl: string;
  cookie: Cookie["cookie"];
  fileName: string;
}): string => {
  const params = createPresignedUrlQueryParameter(cookie);
  const modifiedUrl = manifestFileUrl.replace(/\/[^/]+$/, `/${fileName}`);

  return `${modifiedUrl}?${params}`;
};
